import type { PreviewMap }    from '@/TokamapEditor/stores/PreviewMapsStore';
import type { RouteDocument } from '@tokamap/core';

/**
 * Les cartes d'un projet réduites à ce que `documentConnectivity` regarde : leur identifiant et les
 * zones qui mènent ailleurs.
 *
 * Les identifiants passent en chaînes DES DEUX CÔTÉS : l'API rend des ids numériques là où
 * `Shape.targetDocumentId` est typé `string`, et n'en convertir qu'un fait échouer toutes les
 * comparaisons (3 n'est pas "3") — donc tout paraît isolé et cassé.
 */
export default function toRouteDocuments(maps: Pick<PreviewMap, 'mapId' | 'shapes'>[]): RouteDocument[] {
	return maps.map(map => ({
		documentId: String(map.mapId),
		shapes: map.shapes
			.filter(shape => shape.targetDocumentId !== undefined)
			.map(shape => ({ ...shape, targetDocumentId: String(shape.targetDocumentId) })),
	}));
}
